import { ComponentType, Parameter } from "@/queries/models";

export const PARAMETER_TYPES = [
  {
    label: "Input",
    value: ComponentType.INPUT,
    description: 'Create text parameters such as "Seed" or "Max Tokens".',
  },
  {
    label: "Group",
    value: ComponentType.GROUP,
    description: 'Create a group that links multiple sub-parameters such as "Thinking".',
  },
  {
    label: "Slider",
    value: ComponentType.SLIDER,
    description: 'Create numerical sliders for parameters such as "Temperature" or "Top P".',
  },
  {
    label: "Dropdown",
    value: ComponentType.DROPDOWN,
    description:
      'Create categorical options for parameters such as "Reasoning Effort" or "Response Format".',
  },
  {
    label: "Multi-Select",
    value: ComponentType.MULTI_SELECT,
    description: 'Create multiple choice parameters such as "Modalities" or "Features".',
  },
];

export const PARAMETER_DEFAULT_VALUES: Record<ComponentType, Parameter> = {
  [ComponentType.TAGS]: {
    name: "New Tags",
    param_id: "new_tags",
    component_type: ComponentType.TAGS as ComponentType.TAGS,
    default: [],
    value: [],
    is_disabled: false,
    is_custom: true,
  },
  [ComponentType.INPUT]: {
    name: "New Input",
    param_id: "new_input",
    component_type: ComponentType.INPUT,
    default: "Example Default Value",
    placeholder: "Example Placeholder",
    is_disabled: false,
    is_custom: true,
  },
  [ComponentType.GROUP]: {
    name: "New Group",
    param_id: "new_group",
    component_type: ComponentType.GROUP,
    default: {
      new_group_2: {
        new_select: "option_1",
      },
      new_input_2: "Example Default Value 2",
    },
    is_disabled: false,
    is_custom: true,
    parameters: [
      {
        name: "New Group 2",
        param_id: "new_group_2",
        component_type: ComponentType.GROUP,
        default: {
          new_select: "option_1",
        },
        is_disabled: false,
        is_custom: true,
        parameters: [
          {
            name: "New Select",
            param_id: "new_select",
            component_type: ComponentType.DROPDOWN,
            default: "option_1",
            placeholder: "Example Placeholder",
            is_disabled: false,
            is_custom: true,
            options: [
              {
                display_name: "Option 1",
                value: "option_1",
              },
              {
                display_name: "Option 2",
                value: "option_2",
              },
            ],
          },
        ],
      },
      {
        name: "New Input 2",
        param_id: "new_input_2",
        component_type: ComponentType.INPUT,
        default: "Example Default Value 2",
        placeholder: "Example Placeholder 2",
        is_disabled: false,
        is_custom: true,
      },
    ],
  },
  [ComponentType.SLIDER]: {
    name: "New Slider",
    param_id: "new_slider",
    component_type: ComponentType.SLIDER,
    default: 0,
    step: 1,
    min: 0,
    max: 100,
    is_disabled: false,
    is_custom: true,
  },
  [ComponentType.DROPDOWN]: {
    name: "New Dropdown",
    param_id: "new_dropdown",
    placeholder: "Select an option",
    component_type: ComponentType.DROPDOWN,
    default: "option_1",
    options: [
      {
        display_name: "Option 1",
        value: "option_1",
      },
      {
        display_name: "Option 2",
        value: "option_2",
      },
      {
        display_name: "Option 3",
        value: "option_3",
      },
    ],
    is_disabled: false,
    is_custom: true,
  },
  [ComponentType.MULTI_SELECT]: {
    name: "New Multi-Select",
    param_id: "new_multi_select",
    placeholder: "Select multiple options",
    component_type: ComponentType.MULTI_SELECT,
    default: ["option_1", "option_2"],
    is_array: true,
    is_json: true,
    options: [
      {
        display_name: "Option 1",
        value: "option_1",
      },
      {
        display_name: "Option 2",
        value: "option_2",
      },
      {
        display_name: "Option 3",
        value: "option_3",
      },
    ],
    is_disabled: false,
    is_custom: true,
  },
};
